export class LprReasonResults {
  public reasons: string[];

  public hotlists: string[];
}
